<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created: function () {
    if (location.hostname == "szicpa.fantacg.com") {

      this.$router.push({ path: '/*' })
      return
    }
    let docEle = document.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      resizeFun = () => {
        let clientWidth = docEle.clientWidth;
        if (!clientWidth) return;
        docEle.style.fontSize = 100 * (clientWidth / 1920) + 'px';
      };
    if (!document.addEventListener) return;
    window.addEventListener(resizeEvt, resizeFun, false);
    window.addEventListener('DOMContentLoaded', resizeFun, false);
    resizeFun();
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  font-size: 0.16rem;
  font-family: SourceHanSansSC-Medium, "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
    sans-serif;
}
</style>
